/**
 * Компонент уведомления (toast).
 */
import { useEffect } from 'react';

const TOAST_TYPES = {
  success: {
    bg: 'bg-green-500',
    icon: '✅',
  },
  error: {
    bg: 'bg-red-500',
    icon: '❌',
  },
  info: {
    bg: 'bg-blue-500',
    icon: 'ℹ️',
  },
  warning: {
    bg: 'bg-yellow-500',
    icon: '⚠️',
  },
};

export function Toast({ message, type = 'info', onClose, duration = 4000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [onClose, duration]);

  const { bg, icon } = TOAST_TYPES[type] || TOAST_TYPES.info;

  return (
    <div className={`fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 ${bg} text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 animate-slide-up`}>
      <span className="text-xl">{icon}</span>
      <p className="flex-1">{message}</p>
      <button onClick={onClose} className="hover:opacity-80 transition-opacity">
        ✕
      </button>
    </div>
  );
}

// Добавим анимацию в CSS
export const toastStyles = `
@keyframes slide-up {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-slide-up {
  animation: slide-up 0.3s ease-out;
}
`;
